/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_item = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpSharedContactDealerButton_item";
};
export type PdpSharedContactDealerButton_item$data = PdpSharedContactDealerButton_item;
export type PdpSharedContactDealerButton_item$key = {
    readonly " $data"?: PdpSharedContactDealerButton_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    }
  ]
};
(node as any).hash = '7c677a2f77eb61fc77fbd1a29f460f4a';
export default node;
